import React from "react";
/* eslint-disable */
import {
  Box, Grid, TableBody, TableCell, TableContainer, TableHead, TableRow, Table
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const priceNegotiation = this.props.priceNegotiation;
    const data = this.props.searchData;
    const totalValues = this.props.totalValues;

    return (
      <div align='left' style={{ padding: '15px' }}>
        <h3><center><u>Price Negotiation Audit Summary Report</u></center></h3>
        <div >&nbsp;</div>
        {/* <Grid style={{ padding: '20px' }} container spacing={2}>
          <Grid md={2} xs={2}>
            <h4>Group:</h4>
          </Grid>
          <br />
          <Grid md={10} xs={10}>
            {data.groupID}
          </Grid>
          <br />
          <Grid md={2} xs={2}>
            <h4>Fresh Collection Center:  </h4>
          </Grid>
          <Grid md={10} xs={10}>
            {data.operationEntityID}
          </Grid>
          <Grid md={2} xs={2}>
            <h4>Product Category:  </h4>
          </Grid>
          <Grid md={10} xs={10}>
            {data.cropCategoryID}
          </Grid>
          <Grid md={2} xs={2}>
            <h4>Product:</h4>
          </Grid>
          <Grid md={10} xs={10}>
            {data.cropID}
          </Grid>
          <Grid md={2} xs={2}>
            <h4>From Date:</h4>
          </Grid>
          <Grid md={10} xs={10}>
            {data.fromDate}
          </Grid>
          <Grid md={2} xs={2}>
            <h4>To Date:</h4>
          </Grid>
          <Grid md={10} xs={10}>
            {data.toDate}
          </Grid>
        </Grid> */}
        <div>&nbsp;</div>
        <Box minWidth={1200}>
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell align={'left'}>Proposed Date</TableCell>
                  <TableCell align={'left'}>Fresh Collection Center</TableCell>
                  <TableCell align={'left'}>Product Code</TableCell>
                  <TableCell align={'left'}>Product</TableCell>
                  <TableCell align={'right'}>PP(LKR)</TableCell>
                  <TableCell align={'right'}>AP(LKR)</TableCell>
                  <TableCell align={'right'}>RP(LKR)</TableCell>
                  <TableCell align={'right'}>GP(LKR)</TableCell>
                  <TableCell align={'right'}>SOP(LKR)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
            {priceNegotiation.flatMap((row, index) => {
                const labelId = `enhanced-table-checkbox-${index}`;
                const mainRow = (
                    <TableRow key={`main-row-${index}`}>
                    <TableCell>
                        {new Date(row.priceProposedDate).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        minimumIntegerDigits: 2,
                        })}
                    </TableCell>
                    <TableCell>{row.factoryName}</TableCell>
                    <TableCell>{row.productCode}</TableCell>
                    <TableCell>{row.product}</TableCell>
                    <TableCell align="right">{row.proposedPrice === 0 || row.proposedPrice ? '-' : row.proposedPrice.toFixed(2)}</TableCell>
                    <TableCell align="right">{row.approvedPrice === 0 ? '-' : row.approvedPrice.toFixed(2)}</TableCell>
                    <TableCell align="right">{row.realizedPrice === 0 ? '-' : row.realizedPrice.toFixed(2)}</TableCell>
                    <TableCell align="right">{row.grnPrice === 0 ? '-' : row.grnPrice.toFixed(2)}</TableCell>
                    <TableCell align="right">{row.specialOrderPrice.toFixed(2)== 0 ? '-' : row.specialOrderPrice.toFixed(2)}</TableCell>
                    </TableRow>
                );
                const additionalRows = row.specialOrderPrices?.slice(1).map((price, subIndex) => (
                    <TableRow key={`additional-row-${index}-${subIndex}`}>
                    <TableCell colSpan={8} />
                    <TableCell align="right">{price.toFixed(2) == 0 ? "-": price.toFixed(2)}</TableCell>
                    </TableRow>
              )) || [];
                return [mainRow, ...additionalRows];
                })}
            </TableBody>
              {/* <TableRow>
                <TableCell align="center" colSpan={4} style={{ fontWeight: "bold" }}>Total</TableCell>
                <TableCell align="right" style={{ fontWeight: "bold" }}>
                  {totalValues.totalProposedPrice === 0 || totalValues.totalProposedPrice === "-"
                    ? '-'
                    : parseFloat(totalValues.totalProposedPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </TableCell>
                <TableCell align="right" style={{ fontWeight: "bold" }}>
                  {totalValues.totalApprovedPrice === "-" || totalValues.totalApprovedPrice === 0
                    ? '-'
                    : parseFloat(totalValues.totalApprovedPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </TableCell>
                <TableCell align="right" style={{ fontWeight: "bold" }}>
                  {totalValues.totalRealizedPrice === "-" || totalValues.totalRealizedPrice === 0
                    ? '-'
                    : parseFloat(totalValues.totalRealizedPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </TableCell>
                <TableCell align="right" style={{ fontWeight: "bold" }}>
                  {totalValues.totalGrnPrice === "-" || totalValues.totalGrnPrice === 0
                    ? '-'
                    : parseFloat(totalValues.totalGrnPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </TableCell>
              </TableRow> */}
            </Table>
          </TableContainer>
        </Box>
      </div>
    );
  }
}
